import React from 'react'
import { Button, Dialog, Divider, TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import MaskedInput from 'react-text-mask'
import { change, validateCode } from '../../store/actions/sms.action'
import { changeNotify } from '../../store/actions/notify.action'
import { changeLoading } from '../../store/actions/loading.action'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [/[0-9]/, /\d/ , /\d/, /\d/, /\d/, /\d/ ]

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

const VerifySms = (props) => {
    const { open, type, onClose, onConfirm } = props
    const { code, error } = useSelector(state => state.smsReducer)

    const dispatch = useDispatch()

    const validate = () => {
        dispatch(validateCode({
            code: code,
            type: type
        })).then(res => {
            if(res) {
                dispatch(changeLoading({
                    open: false
                }))
    
                dispatch(change({
                    code: '',
                    open: false,
                    error: {}
                }))

                dispatch(changeNotify({
                    open: true, 
                    msg: res.msg,
                    class: res.class
                }))

                onConfirm()
            }
        })
    }

    return (
        <Dialog
            open={open}
            maxWidth="xl"
            scroll="body"
            className="bs-modal-transparent modal-center"
        >
            <div className="card-rounded card-body bs-bg">
                <h6 className="mb-1 bs-color-b">Verificação adicional</h6>
                <Divider className="mb-2" />

                <div className="alert alert-warning" role="alert">
                Sua conta é protegida com <strong>autenticação multifator (SMS)</strong>
                </div>
                
                <div className="mb-3">
                    <label className="label-custom mt-3 pb-1 bs-color-b">SMS Code</label>

                    <TextField
                        fullWidth
                        placeholder="CODE"
                        margin="normal"
                        className="mt-0"
                        type="tel"
                        autoComplete="off"
                        InputProps={{
                            inputComponent: TextMaskCustom,
                            value: code || '',
                            onChange: text => dispatch( change({ code: text.target.value }) )
                        }}
                    />

                    {(error?.code) &&
                        <strong className="text-danger d-block">{error?.code[0]}</strong>
                    }
                </div>

                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    className="mb-3 bg-primary"
                    onClick={() => validate()}
                >
                    Avançar
                </Button>

                <Button
                    fullWidth
                    className='btn-white fw-bold bs-color-b'
                    onClick={() => {
                        dispatch(change({
                            code: '',
                            open: false,
                            error: {}
                        }))

                        onClose()
                    }}
                >
                    Voltar
                </Button>
            </div>
        </Dialog>
    )
}

export default VerifySms